import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const TASK_DETAILS = FORM_FIELDS.TASK_DETAILS;

export const { WING_DESK_IO_E0, DESIGNATION } =
  FORM_FIELDS.EMPLOYEE.GENERAL_INFO;

const {
  ASSIGNED_PERSON,
  ATTACHMENTS,
  DETAILS,
  END_DATE,
  NAME_OF_TASK,
  PREREQUISITES,
  PRIORITY,
  STATUS,
  REMARKS,
  SHARED_PERSON,
  START_DATE,
} = TASK_DETAILS;

export const taskDetailsValidation = yup.object().shape({
  [NAME_OF_TASK]: yup.string().required("Name is required"),
  [DETAILS]: yup.string(),
  [START_DATE]: yup.string().required("Start date is required"),
  [END_DATE]: yup.string().required("End date is required"),
  [PREREQUISITES]: yup.string(),
  [ASSIGNED_PERSON]: yup.number().nullable(),
  [`${WING_DESK_IO_E0}-${ASSIGNED_PERSON}`]: yup.number().nullable(),
  [`${DESIGNATION}-${ASSIGNED_PERSON}`]: yup.number().nullable(),
  [`${WING_DESK_IO_E0}-${SHARED_PERSON}`]: yup.number().nullable(),
  [`${DESIGNATION}-${SHARED_PERSON}`]: yup.number().nullable(),
  [SHARED_PERSON]: yup.array().nullable(),
  [PRIORITY]: yup.string(),
  [STATUS]: yup.string().required("Status is required"),
  [REMARKS]: yup.string(),
  [ATTACHMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable(),
});

export type TaskDetailsFormDataType = yup.InferType<
  typeof taskDetailsValidation
>;
